export default ({ palette, typography }) => ({
  link: {
    color: palette.secondary,
    fontFamily: typography.p.fontFamily,
    fontSize: 18,
    hoverColor: palette.secondary,
  },
  linkSecondaryBold: {
    fontSize: 16,
    fontWeight: typography.fontWeights.bold,
  },
  linkTertiary: {
    fontSize: 14,
  },
  linkTertiaryBold: {
    fontSize: 14,
    fontWeight: typography.fontWeights.bold,
  },
});
